module.exports = __webpack_public_path__ + "img/messages.46da8b79.svg";